import {APIPlatformSerializer} from './abstract';
import {PROVIDER} from '../../../resources';

export class DocumentTypeSerializer extends APIPlatformSerializer {
  base = PROVIDER.DOCUMENT_TYPES;

  serialize(data) {
    this.labelFr = data.labelFr;
    this.labelEn = data.labelEn;
    this.code = data.code;
  }
}
